import { useEffect } from "react";

let lockCount = 0;

/**
 * Prevents the page behind a modal or drawer from scrolling.
 *
 * Reference-counted, so a lightbox opened from inside the drawer doesn't
 * release the lock when only one of the two closes. Also pads for the
 * scrollbar's width to stop the layout jumping sideways.
 */
export const useLockBodyScroll = (locked: boolean) => {
  useEffect(() => {
    if (!locked) return;

    lockCount += 1;

    if (lockCount === 1) {
      const gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = gap > 0 ? `${gap}px` : "";
      document.body.classList.add("is-locked");
    }

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        document.body.classList.remove("is-locked");
        document.body.style.paddingRight = "";
      }
    };
  }, [locked]);
};

export default useLockBodyScroll;
